/**
 * function to create custom data for select input
 * based on data passing as props
 */
export const createData = (data) => {
  let newData = data.map((item) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
  return newData;
};

export const createDataWithLabel = (data) => {
  let newData = data.map((item) => {
    return {
      value: item.id,
      label: item.label,
    };
  });
  return newData;
};

export const createDataWithText = (data) => {
  let newData = data.map((item) => {
    return {
      value: item.id,
      label: item.text,
    };
  });
  return newData;
};

export const createDataWithOffices = (data) => {
  let newData = data.map((item) => {
    return {
      value: item.office_id,
      label: item.name,
    };
  });
  return newData;
};
